import styled, { CSSProperties } from "styled-components";

export interface FrameProps {
  border?: CSSProperties["border"];
}

export const Frame = styled.div<FrameProps>`
  border: ${({ border, theme }) =>
    border || `${theme.borders.width.xs2} solid ${theme.colors.neutral[90]}`};
  border-radius: ${({ theme }) => theme.borders.radius.m};
`;
